import { create } from "zustand";

export type StreamingPhase = "topics" | "questions" | "vocabulary" | "speaking-guide" | "generating-all" | null;

interface TopicGenerationStatusState {
    streamingPhase: StreamingPhase;
    loading: boolean;
    slug: string | null;
    sessionId: string | null;
    topic: string | null;
    setStatus: (phase: StreamingPhase, loading: boolean, slug?: string | null, sessionId?: string | null, topic?: string | null) => void;
    clearStatus: () => void;
}

export const useTopicGenerationStatusStore = create<TopicGenerationStatusState>()((set) => ({
    streamingPhase: null,
    loading: false,
    slug: null,
    sessionId: null,
    topic: null,

    setStatus: (phase, isLoading, newSlug?, newSessionId?, newTopic?) => {
        set({
            streamingPhase: phase,
            loading: isLoading,
            ...(newSlug !== undefined && { slug: newSlug }),
            ...(newSessionId !== undefined && { sessionId: newSessionId }),
            ...(newTopic !== undefined && { topic: newTopic }),
        });
    },

    clearStatus: () => {
        set({
            streamingPhase: null,
            loading: false,
            slug: null,
            sessionId: null,
            topic: null,
        });
    },
}));
